import {useCallback} from 'react';

import {CREATE_TEEN_EVENTS} from '@/app/auth/events/CreateTeenEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = (themeSelected: string) => {
  const {trackEvent} = useTrackingManager();

  const trackViewAddKidCardThemeModal = useCallback(() => {
    trackEvent(CREATE_TEEN_EVENTS.VIEW_ADD_KID_CARD_THEME_MODAL, {
      project_tag: PROJECT_TAGS.ONBOARDING,
      Banking: {
        card: {
          theme: {
            name: themeSelected ?? '',
          },
        },
      },
    });
  }, [themeSelected, trackEvent]);

  const trackSelectAddKidChangeCardTheme = useCallback(() => {
    trackEvent(CREATE_TEEN_EVENTS.SELECT_ADD_KID_CHANGE_CARD_THEME, {
      project_tag: PROJECT_TAGS.ONBOARDING,
      Banking: {
        card: {
          theme: {
            name: themeSelected ?? '',
          },
        },
      },
    });
  }, [themeSelected, trackEvent]);

  const trackSelectAddKidDobContinue = useCallback(() => {
    trackEvent(CREATE_TEEN_EVENTS.SELECT_ADD_KID_NAME_DOB_CONTINUE, {
      project_tag: PROJECT_TAGS.ONBOARDING,
      Banking: {
        card: {
          theme: {
            name: themeSelected ?? '',
          },
        },
      },
    });
  }, [themeSelected, trackEvent]);

  const trackSelectAddKidNewCardTheme = useCallback(() => {
    trackEvent(CREATE_TEEN_EVENTS.SELECT_ADD_KID_NEW_CARD_THEME, {
      project_tag: PROJECT_TAGS.ONBOARDING,
      Banking: {
        card: {
          theme: {
            name: themeSelected ?? '',
          },
        },
      },
    });
  }, [themeSelected, trackEvent]);

  const trackViewAddKidNameDob = useCallback(() => {
    trackEvent(CREATE_TEEN_EVENTS.VIEW_ADD_KID_NAME_DOB, {
      project_tag: PROJECT_TAGS.ONBOARDING,
      Banking: {
        card: {
          theme: {
            name: themeSelected ?? '',
          },
        },
      },
    });
  }, [themeSelected, trackEvent]);

  return {
    trackViewAddKidCardThemeModal,
    trackSelectAddKidChangeCardTheme,
    trackSelectAddKidDobContinue,
    trackSelectAddKidNewCardTheme,
    trackViewAddKidNameDob,
  };
};
